export const REPORTS_ROUTE_STORAGE_KEY = 'reports-route'
